/** Block types supported in AOP markdown code */
export enum ECodeBlockType {
  HEADING = 'heading',
  PARAGRAPH = 'paragraph',
  ORDERED_LIST = 'orderedList',
  UNORDERED_LIST = 'unorderedList',
}

/** Diff status for a block comparison */
export enum EDiffStatus {
  UNCHANGED = 'unchanged',
  ADDED = 'added',
  REMOVED = 'removed',
  MODIFIED = 'modified',
}

/** Diff mark types for TipTap */
export enum EDiffMark {
  ADDED = 'diffAdded',
  DELETED = 'diffDeleted',
}

/** Represents a parsed block from AOP markdown code */
export interface ICodeBlock {
  type: ECodeBlockType;
  /** Heading level (1-6), only applicable for heading blocks */
  level?: number;
  content: string;
}

/** Represents a diff result for a single block */
export interface IBlockDiff {
  status: EDiffStatus;
  blockType: ECodeBlockType;
  level?: number;
  oldContent?: string;
  newContent?: string;
}

/** A section of the document starting with a header */
export interface ISection {
  header: ICodeBlock | null;
  content: ICodeBlock[];
}
